@if (invalidML) {
  <div class="alert alert-danger">
    <strong>Achtung!</strong>
    @switch (errorMl) {
      @case ('ml.missing') {
        Der Multilayeraufbauplan ist vom Artikel vorgegeben, wurde aber nicht erstellt.
      }
      @case ('ml.differs') {
        Die Werte im Multilayeraufbauplan weichen vom Artikel ab.
      }
      @default {
        Bitte Multilayerplan überprüfen.
      }
    }
  </div>
}
